import { Attributes, Misc, ModelBase, ValueObject } from '@singularsystems/neo-core';

export default class InterestRateImportResult extends ModelBase {

    constructor() {
        super();
        this.makeObservable();
    }

    @Attributes.Raw()
    public fileErrors: string[] = [];

    @Attributes.Raw()
    public rowErrors: string[] = [];

    // Client only properties / methods

    public get hasErrors() {
        return this.rowErrors.length > 0 || this.fileErrors.length > 0;
    }
}